import handler from '../handler/handler';
import messages from '../handler/messages/wine-messages';

const statusHandler = handler(messages);

export default {
  actions: {
    getDashboard: async ({ commit, getters }, options) => {
      const result = await statusHandler.authGet({ commit, getters }, '/api/dashboard', {
        params: {
          period: options.period,
          start: options.start,
          end: options.end,
        },
      });

      return result.response;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/dashboard.js